export default __webpack_public_path__ + "static/media/Pawdopt2.8c0118d9.webp";